import { render, staticRenderFns } from "./RuleSetting.vue?vue&type=template&id=f2f71188&scoped=true&"
import script from "./RuleSetting.vue?vue&type=script&lang=js&"
export * from "./RuleSetting.vue?vue&type=script&lang=js&"
import style0 from "./RuleSetting.vue?vue&type=style&index=0&id=f2f71188&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2f71188",
  null
  
)

export default component.exports